import React, {ReactElement} from "react";
import ZeeroLoading from "../custom/ZeeroLoading";
import {useTranslation} from "react-i18next";

export default function LoadingPage(): ReactElement {
	const {t} = useTranslation();

	return (
			<div id="loading-screen">
				<ZeeroLoading message={t("general_loadingISU")} appendEllipsis={false}/>
			</div>
	)
}